import React from 'react';

import Form from './Form';

export default class TooltipDropdownField extends React.Component {
  state = {};

  render() {
    return (
      <Form.Field
        {...this.props}
        withTooltip
        onToggle={isOpen => {
          this.setState({ isOpen });
        }}
        placement={this.state.isOpen && !this.props.isSmall ? 'left' : 'top'}
      />
    );
  }
}
